import React from 'react';

import * as Icon from 'ubs-icons';

const UPermissionPopup = (props) => {
    return (
        <React.Fragment>
            <div className="u_version-popup">
                <div className="u_version-popup-overlay"/>
                <div className="u_version-popup-inner">
                    <div className="u_version-popup-header">
                        <h3>{props.moduleIcon} {props.moduleName}</h3>
                    </div>
                    <div className="u_version-popup-body">
                        <Icon.Warning size={30} fill="#FFA700"/>
                        <div className="u_popup-content">
                            <h4>Your permissions have been updated.</h4>
                            <p>Refresh your page and continue...</p>
                        </div>
                    </div>
                    <div className="u_version-popup-footer">
                        {
                            props.refresh &&
                            <div>
                                <button className="u_button u_button-blue"
                                        onClick={() => props.refresh()}>Refresh
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UPermissionPopup;